function SignupController(){

}
SignupController.$inject = [];
export default SignupController;